import { render, staticRenderFns } from "./ModelProfile.vue?vue&type=template&id=94c81d76&"
import script from "./ModelProfile.vue?vue&type=script&lang=js&"
export * from "./ModelProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModelProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports